import type { MaybeRefOrGetter, Ref } from 'vue'
import { ref } from 'vue'
import { useLocalStorage } from '@vueuse/core'
import { logger } from 'utils'

/**
 * Wrapper around VueUse's `useLocalStorage` that catches `SecurityError`
 * thrown when storage access is blocked (cross-origin iframes, tracking
 * protection, sandboxed contexts). Falls back to a plain in-memory `ref`.
 */
export function useSafeLocalStorage<T>(
    key: MaybeRefOrGetter<string>,
    initialValue: T,
): Ref<T> {
    try {
        // Probe: if localStorage is blocked, this throws immediately
        window.localStorage.getItem('')
        return useLocalStorage<T>(key, initialValue)
    } catch (error) {
        logger.warn(
            '[useSafeLocalStorage] localStorage blocked, falling back to in-memory ref',
            error,
        )
        return ref(initialValue) as Ref<T>
    }
}
